
import config from '../../config'
import checkApiResponse from './checkApiResponse'

/**
 * @func: postProviderCredentials
 * @return {[Object]} data
 *
 * @description:
 */

const postProviderCredentials = (id, login, pass) => {
  const params = { id_provider: id, login: login, pass: pass }
  return config.API.providerCredentialsPost({}, params, {})
  .then(result => result.data)
  .catch(error => checkApiResponse(error))
}


export default postProviderCredentials
